module.exports = __webpack_public_path__ + "static/media/styles.fed58005.less";